import { AttributeObserver } from '@hotwired/stimulus'
import { CONTROLLER_ATTRIBUTE } from './helpers'

export const TEXT_DECORATION_CONFIG_ATTRIBUTE = 'data-text-decoration-config'
const TEXT_DECORATION_STYLE_PATTERN = /^[a-z0-9-]+$/

// The sanitizer strips data-controller/data-action from rich text but keeps
// data-text-decoration-config, so rebuild the (fixed-prefix) controller from it.
export function activateTextDecorationController(
  element: Element,
  isAvailable: (controllerName: string) => boolean
) {
  const rawConfig = element.getAttribute(TEXT_DECORATION_CONFIG_ATTRIBUTE)
  if (!rawConfig) return

  let style: unknown
  try {
    style = JSON.parse(rawConfig)?.style
  } catch (_) {
    return
  }
  if (typeof style !== 'string' || !TEXT_DECORATION_STYLE_PATTERN.test(style))
    return

  const controllerName = `text-decoration--${style}`
  if (!isAvailable(controllerName)) return

  const controllers = (element.getAttribute(CONTROLLER_ATTRIBUTE) || '')
    .split(/\s+/)
    .filter(Boolean)
  if (!controllers.includes(controllerName)) {
    element.setAttribute(
      CONTROLLER_ATTRIBUTE,
      [...controllers, controllerName].join(' ')
    )
  }
  if (!element.hasAttribute('data-action')) {
    element.setAttribute(
      'data-action',
      `text-decoration-restart-animation->${controllerName}#restartAnimation`
    )
  }
}

export function observeTextDecorations(
  root: Element,
  isAvailable: (controllerName: string) => boolean
) {
  const activate = (element: Element) =>
    activateTextDecorationController(element, isAvailable)
  new AttributeObserver(root, TEXT_DECORATION_CONFIG_ATTRIBUTE, {
    elementMatchedAttribute: activate,
    elementAttributeValueChanged: activate,
  }).start()
}
